import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import OnboardingLayout from './OnboardingLayout'

import { Select, SelectWrapper, TextField } from '../marketing/MarketingStyles';

import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

@inject('utilStore')
@observer
class MultistepForm extends Component {

  // sampleProperties = {
  //   title: 'Dr.',
  //   firstname: 'Raphael',
  //   lastname: 'Dick',
  //   birthdate: '08 / 06 / 2000',
  //   // city: 'Wien',
  //   // postcode: '1220',
  //   // address: 'Laudongasse 2 Top 2',
  //   mail: 'raphael.dick@fuchsfabrik.at',
  //   phone: '+43 123 3123 12',
  //   known_member: 'Schnöll',
  //   company: 'Fuchsfabrik',
  //   uid: 'ATU123456789',
  //   industry: 'luxusartikel',
  //   industry_name: 'Luxusartikel',
  //   company_city: 'Wien',
  //   company_postcode: '1080',
  //   company_address: 'Laudongasse 1 Top 5',
  //   position: 'CEO',
  //   golf_course: 'Wienerberg',
  //   handicap: '0',
  //   region: undefined
  // }

  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      subIndex: 0,
      // properties: this.sampleProperties,
      properties: {},
      CurrentContent: undefined,
      errors: [],
      update: false,
    }
  }

  componentDidMount() {
    this.updateCurrent()

    if(this.props.onRef)
      this.props.onRef(this)
  }

  componentDidUpdate() {
    if( this.state.update == true) {
      this.updateCurrent()
      this.setState({ update: false, })
    }
  }

  componentWillUnmount() {
    if(this.props.onRef)
      this.props.onRef(undefined)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.state.CurrentContent != nextState.CurrentContent) return true;
    if(this.state.properties != nextState.properties) return true;
    if(nextState.update) return true;
    return false
  }

  updateCurrent = () => {
    const props = {
      next: this.next,
      select: this.select,
      Progressbar: this.Progressbar,
      updateProperty: this.updateProperty,
      properties: this.state.properties,
      TrackedTextField: this.TrackedTextField,
      TrackedSelectField: this.TrackedSelectField,
      TrackedDatePicker: this.TrackedDatePicker,
      selectSub: this.selectSub,
    }

    this.setState({ CurrentContent: React.cloneElement(this.props.steps[ this.state.index ].components[ this.state.subIndex ](), props) })
  }

  next = () => {
    this.setState({ index: this.state.index + 1, subIndex: 0 }, this.updateCurrent)
  }

  select = ( i ) => {
    this.setState({ index: i, subIndex: 0 }, this.updateCurrent)
  }

  selectSub = ( i ) => {
    this.setState({ subIndex: i }, this.updateCurrent)
  }

  Progressbar = () => (
    <ProgressbarWrapper>
      {
        this.props.steps.map( (step, i) => {

          const color = i == this.state.index ? cssVar.colors.gold : i > this.state.index ? cssVar.colors.light_grey : cssVar.colors.blue;

          return (
            <ProgressbarItem
              key={ step.title }
              color={ color }
              selected={ i == this.state.index }
              onClick={ () => i < this.state.index && !step.revisitLocked ? this.select(i) : '' }
              available={ i < this.state.index && !step.revisitLocked }
            >
              { step.title }
            </ProgressbarItem>
          )
        })
      }
    </ProgressbarWrapper>
  )

  updateProperty = (slug, value, rerender) => {
    const properties = this.state.properties
    properties[slug] = value
    this.setState({ properties, update: rerender })
  }

  updateProperties = (properties, rerender) => {
    this.setState({ properties, update: rerender })
  }

  TrackedTextField = ({ slug, ...props }) => <TextField key={slug} name={slug} onBlur={e => this.updateProperty(slug, e.target.value) } defaultValue={ this.state.properties[slug] } {...props}/>

  TrackedSelectField = ({ slug, onChange, rerender, ...props }) =>  <SelectWrapper><Select key={slug} name={slug} defaultValue={ this.state.properties[slug] || '' } onChange={e => { this.updateProperty(slug, e.target.value, rerender); onChange && onChange(e.target.value) }} {...props} /></SelectWrapper>

  TrackedDatePicker = ({ slug, placeholder, ...props }) => {

    const DateInput = ({ value, onClick }) => ( <TextField placeholder={placeholder} onClick={onClick} required value={this.state.properties[slug]} readOnly/>)

    return (
      <DatePicker
        style={{width: "100%", color: "black"}}
        selected={ this.state.properties[slug] ? moment(this.state.properties[slug], "DD / MM / YYYY") : moment().subtract(20, 'years')}
        onChange={date => { this.updateProperty(slug, date.format("DD / MM / YYYY")) } }
        withPortal
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        fixedHeight
        dateFormatCalendar={"MMM YYYY"}
        dropdownMode="select"
        minDate={moment().subtract(100, 'years')}
        maxDate={moment().subtract(20, 'years')}
        customInput={<DateInput />}
      />
    )
  }

  render() {

    if(!this.state.CurrentContent) return (<div>loading</div>)

    const CurrentContent = () => this.state.CurrentContent

    return (
      <CurrentContent />
    )
  }
}

export default MultistepForm


const ProgressbarWrapper = styled.div `
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  padding-bottom: 80px;

  ${cssVar.breakpoints.phone} {
    gap: 10px;
  }
`

const ProgressbarItem = styled.div `
  flex: 1;
  color: ${props => props.color};
  border-bottom: 5px solid ${props => props.color};
  cursor: ${props => props.available ? 'pointer' : 'inherit'};
  font-size: 0.9em;
  padding-bottom: 5px;

  ${cssVar.breakpoints.phone} {
    font-size: ${props => props.selected ? '' : '0'};
    padding-top: 10px;
    padding-bottom: 0;
    text-align: center;
    border-bottom: none;
    margin-top: ${props => props.selected ? '-5px' : '0'};
    border-top: ${props => props.selected ? '20px' : '10px'} solid ${props => props.color};
  }
`



// WEBPACK FOOTER //
// /src/components/onboarding/MultistepForm.js